import { Box, Typography } from '@mui/material';

import { PieceAction } from '@apiContract';
import { DialogConfirmation } from '@uiKit/DialogConfirmation';

import { showApiErrorToast } from '@utils/apiErrorToast';

import { useFinishPieceMutation } from '../../hooks/useFinishPieceMutation';
import { ActionComponentProps } from '../../index';
import NotifyMairoomComment from './NotifyComment';
import useNotifyComment from './NotifyComment/useNotifyComment';

export const Archive = ({ mailpieces, actionStarted, onActionFinish, isForce }: ActionComponentProps) => {
  const { runAction, isLoading } = useFinishPieceMutation();

  const { values, changeValues } = useNotifyComment();

  const confirmAction = async () => {
    try {
      await runAction({
        action: PieceAction.ForceArchive,
        pieces: mailpieces,
        comment: values.comment,
        notifyMailroom: values.notifyMailroom,
        additionalData: { isForce },
      });

      onActionFinish();
    } catch (error) {
      showApiErrorToast(error);
    }
  };

  const content = (
    <Box>
      {mailpieces.length === 1 ? (
        <Typography variant="body1" color="text.secondary">
          Are you sure you would like to archive this item?
        </Typography>
      ) : (
        <Typography variant="body1" color="text.secondary">
          Are you sure you would like to archive <strong>{mailpieces.length}</strong> items?
        </Typography>
      )}
      <NotifyMairoomComment values={values} onChange={changeValues} withSkipNotifyRecipient={false} />
    </Box>
  );

  return (
    <DialogConfirmation
      open={actionStarted}
      loading={isLoading}
      maxWidth="sm"
      title={mailpieces.length === 1 ? 'Archive item' : 'Archive selected items'}
      content={content}
      acceptButtonHandleClick={confirmAction}
      cancelButtonHandleClick={onActionFinish}
      acceptButtonTitle="Archive"
      cancelButtonTitle="Cancel"
    />
  );
};
